<!-- eslint-disable vue/multi-word-component-names -->
<template>
    <a-modal width="520px" class="edit_modal_82" title="选择主体" :confirmLoading="loading" v-model:open="open"
        @ok="postCompanyIdentityData">
        <div class="select_company">
            <div v-for="item in companyIdentUsers" :key="item.companyIdentity"
                :class="formData.companyIdentity == item.companyIdentity ? 'select_company_row_color' : 'select_company_row'"
                @click="onSelectCompany(item)">
                <span v-if="item.companyIdentity == 'cx'">广告管理</span>
                <span v-else-if="item.companyIdentity == 'land'">商业管理</span>
            </div>
        </div>
    </a-modal>
</template>

<script setup>
import { useStore } from "vuex";
import { useRouter } from 'vue-router';
import { ref, defineExpose } from 'vue';
import { postCompanyIdentity } from '@/request/https/login';
import { getDynamicRoutesData } from '@/permission';

const store = useStore();
const router = useRouter();
const open = ref(false);
const loading = ref(false);
const formData = ref({});
const companyIdentUsers = ref([]);

/**
 * @function 打开弹框初始化
 * @param data 
 */
const init = (data) => {
    let userId = null;
    companyIdentUsers.value = data.companyIdentUsers.map(item => {
        if(item.companyIdentity == localStorage.getItem('user_login_identity')) userId = item.userId;
        return item;
    });
    if(localStorage.getItem('user_login_identity')) formData.value = {
        userId: userId,
        companyIdentity: localStorage.getItem('user_login_identity')
    };
    else formData.value = {
        userId: companyIdentUsers.value[0]?.userId,
        companyIdentity: companyIdentUsers.value[0]?.companyIdentity
    };
    open.value = true;
};

/**
 * @function 确认
 */
const onSelectCompany = (data) => {
    formData.value.userId = data.userId;
    formData.value.companyIdentity = data.companyIdentity;
};

/**
 * @function 选择平台
 */
const postCompanyIdentityData = async () => {
    loading.value = true;
    const res = await postCompanyIdentity(formData.value);
    if (res.code == 0) {
        localStorage.clear();
        localStorage.setItem('token', res.data.token);
        localStorage.setItem('user_login_identity', formData.value.companyIdentity);
        store.dispatch("getUserInfoData", res.data);
        const dynamicRoutes = await getDynamicRoutesData();
        await dynamicRoutes.forEach((route) => {
            router.addRoute(route)
        });
        localStorage.setItem('router_data_list', JSON.stringify(dynamicRoutes));
        if (formData.value.companyIdentity == 'cx') router.push('/toBeDone');
        else if (formData.value.companyIdentity == 'land') router.push('/business/cstomer');
        open.value = false;
    }
    loading.value = false;
};

defineExpose({
    init: init
});
</script>

<style lang="scss" scoped>
@use '@/_variables';

.select_company {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .select_company_row {
        width: calc((100% - 16px) / 2);
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding: 16px;
        border: 1px solid #eee;
        border-radius: 8px;
        cursor: pointer;
    }

    .select_company_row_color {
        width: calc((100% - 16px) / 2);
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding: 16px;
        border: 1px solid variables.$hover-font-color;
        border-radius: 8px;
        cursor: pointer;
    }
}
</style>
